(function () {
  var DATA_CACHE_KEY = '__buyereviewsDataPromise';

  function slugify(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getQueryParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name) || '';
  }

  function formatNumber(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) {
      return '';
    }
    return number.toLocaleString('en-US');
  }

  function formatScore(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) {
      return value ? String(value) : '';
    }
    var fixed = number.toFixed(1);
    return fixed.endsWith('.0') ? fixed.slice(0, -2) : fixed;
  }

  function toTitleCase(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\b[a-z]/g, function (char) {
        return char.toUpperCase();
      });
  }

  function parseFeatures(text) {
    if (!text) {
      return [];
    }
    return String(text)
      .split(/\n+/)
      .map(function (line) {
        return line.replace(/^[-•\s]+/, '').trim();
      })
      .filter(Boolean);
  }

  function buildUrl(base, params) {
    if (!base) {
      return '';
    }
    var url = new URL(base, window.location.origin);
    Object.keys(params || {}).forEach(function (key) {
      if (params[key]) {
        url.searchParams.set(key, params[key]);
      }
    });
    return url.toString();
  }

  function loadData(url) {
    if (!url) {
      return Promise.resolve([]);
    }
    var cached = window[DATA_CACHE_KEY];
    if (cached && cached.url === url) {
      return cached.promise;
    }
    var promise = fetch(url)
      .then(function (response) {
        return response.json();
      })
      .catch(function () {
        return [];
      });
    window[DATA_CACHE_KEY] = { url: url, promise: promise };
    return promise;
  }

  function findCategory(data, slug) {
    if (!Array.isArray(data)) {
      return null;
    }
    var targetSlug = slugify(slug);
    if (!targetSlug) {
      return data[0] || null;
    }
    return (
      data.find(function (item) {
        return slugify(item.category_name) === targetSlug;
      }) ||
      data[0] ||
      null
    );
  }

  function findList(category, slug) {
    if (!category || !Array.isArray(category.list_page)) {
      return null;
    }
    var targetSlug = slugify(slug);
    if (!targetSlug) {
      return category.list_page[0] || null;
    }
    return (
      category.list_page.find(function (item) {
        return slugify(item.list_page_name) === targetSlug;
      }) ||
      category.list_page[0] ||
      null
    );
  }

  function renderCategories(root) {
    if (!root || root.dataset.rendered) {
      return;
    }
    root.dataset.rendered = 'true';
    var source = root.dataset.source;
    var categoryUrl = root.dataset.categoryUrl || '';
    var items = root.querySelector('[data-buyereviews-items]');
    var template = root.querySelector(
      "template[data-buyereviews-template='category']",
    );
    if (!items || !template) {
      return;
    }
    loadData(source).then(function (data) {
      items.innerHTML = '';
      if (!Array.isArray(data)) {
        return;
      }
      data.forEach(function (category) {
        var node = template.content.firstElementChild.cloneNode(true);
        var link = node.querySelector('.categories-grid__link');
        var img = node.querySelector('[data-buyereviews-image]');
        var label = node.querySelector('[data-buyereviews-label]');
        var slug = slugify(category.category_name);
        if (link && categoryUrl) {
          link.href = buildUrl(categoryUrl, { category: slug });
        }
        if (img) {
          img.src = category.category_img || '';
          img.alt = category.category_name || '';
        }
        if (label) {
          label.textContent = category.category_name || '';
        }
        items.appendChild(node);
      });
    });
  }

  function renderCategoryLists(root) {
    if (!root || root.dataset.rendered) {
      return;
    }
    root.dataset.rendered = 'true';
    var source = root.dataset.source;
    var detailUrl = root.dataset.detailUrl || '';
    var titleSuffix = root.dataset.titleSuffix || '';
    var items = root.querySelector('[data-buyereviews-items]');
    var template = root.querySelector(
      "template[data-buyereviews-template='list']",
    );
    var title = root.querySelector('[data-buyereviews-title]');
    if (!items || !template) {
      return;
    }
    var categoryParam = getQueryParam('category');
    loadData(source).then(function (data) {
      var category = findCategory(data, categoryParam);
      if (!category) {
        return;
      }
      if (title) {
        var baseTitle = category.category_name || '';
        var suffix = titleSuffix ? ' ' + titleSuffix : '';
        title.textContent = toTitleCase((baseTitle + suffix).trim());
      }
      items.innerHTML = '';
      (category.list_page || []).forEach(function (listPage) {
        var node = template.content.firstElementChild.cloneNode(true);
        var link = node.querySelector('.appliances-products-grid__link');
        var img = node.querySelector('[data-buyereviews-image]');
        var label = node.querySelector('[data-buyereviews-label]');
        var listSlug = slugify(listPage.list_page_name);
        var categorySlug = slugify(category.category_name);
        if (link && detailUrl) {
          link.href = buildUrl(detailUrl, {
            category: categorySlug,
            list: listSlug,
          });
        }
        if (img) {
          img.src = listPage.list_page_image || '';
          img.alt = listPage.list_page_name || '';
        }
        if (label) {
          label.textContent = listPage.list_page_name || '';
        }
        items.appendChild(node);
      });
    });
  }

  function renderSummary(root) {
    if (!root || root.dataset.rendered) {
      return;
    }
    root.dataset.rendered = 'true';
    var source = root.dataset.source;
    var categoryParam = getQueryParam('category');
    var listParam = getQueryParam('list');
    loadData(source).then(function (data) {
      var category = findCategory(data, categoryParam);
      if (!category) {
        return;
      }
      var listPage = findList(category, listParam);
      if (!listPage || !listPage.list_page_data) {
        return;
      }
      var dataSet = listPage.list_page_data;
      var title = root.querySelector("[data-field='title']");
      var description = root.querySelector("[data-field='description']");
      var date = root.querySelector("[data-field='date']");
      if (title && dataSet.title) {
        title.textContent = dataSet.title;
      }
      if (description && dataSet.description) {
        description.textContent = dataSet.description;
      }
      if (date && dataSet.updated) {
        date.textContent = dataSet.updated;
      }
    });
  }

  function renderProducts(root) {
    if (!root || root.dataset.rendered) {
      return;
    }
    root.dataset.rendered = 'true';
    var source = root.dataset.source;
    var buttonText = root.dataset.buttonText || 'Check Price';
    var salesText = root.dataset.salesText || '';
    var showSales = root.dataset.showSales === 'true';
    var items = root.querySelector('[data-buyereviews-items]');
    if (!items && root.hasAttribute('data-buyereviews-items')) {
      items = root;
    }
    var template = root.querySelector(
      "template[data-buyereviews-template='product']",
    );
    if (!items || !template) {
      return;
    }
    var categoryParam = getQueryParam('category');
    var listParam = getQueryParam('list');
    loadData(source).then(function (data) {
      var category = findCategory(data, categoryParam);
      if (!category) {
        return;
      }
      var listPage = findList(category, listParam);
      if (!listPage || !listPage.list_page_data) {
        return;
      }
      var listData = listPage.list_page_data;
      var products = listData.product_list || [];
      items.innerHTML = '';
      products.forEach(function (product) {
        var node = template.content.firstElementChild.cloneNode(true);
        var tag = node.querySelector('[data-buyereviews-tag]');
        var discount = node.querySelector('[data-buyereviews-discount]');
        var img = node.querySelector('[data-buyereviews-image]');
        var title = node.querySelector('[data-buyereviews-title]');
        var features = node.querySelector('[data-buyereviews-features]');
        var score = node.querySelector('[data-buyereviews-score]');
        var stars = node.querySelector('[data-buyereviews-stars]');
        var reviews = node.querySelector('[data-buyereviews-reviews]');
        var sales = node.querySelector('[data-buyereviews-sales]');
        var button = node.querySelector('[data-buyereviews-button]');

        var tagText = product.product_tag || '';
        if (tag) {
          if (tagText) {
            tag.textContent = tagText;
          } else {
            tag.style.display = 'none';
          }
        }

        var discountValue = Number(product.product_discountPercentage || 0);
        if (discount) {
          if (discountValue > 0) {
            discount.textContent = discountValue + '% off';
          } else {
            discount.style.display = 'none';
          }
        }

        if (img) {
          img.src = product.product_image || '';
          img.alt = product.product_display_name || '';
        }
        if (title) {
          title.textContent = product.product_display_name || '';
        }
        if (features) {
          var featureItems = parseFeatures(product.product_description);
          if (!featureItems.length) {
            features.style.display = 'none';
          } else {
            featureItems.forEach(function (line) {
              var li = document.createElement('li');
              li.textContent = line;
              features.appendChild(li);
            });
          }
        }

        if (score) {
          score.textContent = formatScore(product.product_grade);
        }

        if (stars) {
          var rating = Number(product.product_rating || 0);
          var starCount = Math.max(0, Math.min(5, Math.round(rating)));
          stars.innerHTML = '';
          for (var i = 1; i <= 5; i += 1) {
            var star = document.createElement('span');
            star.className = 'ranking-product-card__star';
            if (i > starCount) {
              star.className += ' ranking-product-card__star--inactive';
            }
            star.textContent = '★';
            stars.appendChild(star);
          }
        }

        if (reviews) {
          var reviewValue = Number(product.product_reviews || 0);
          if (reviewValue > 0) {
            reviews.textContent = '(' + formatNumber(reviewValue) + ' reviews)';
          } else {
            reviews.style.display = 'none';
          }
        }

        if (sales) {
          var productSales =
            product.product_sales || product.product_sales_text || salesText;
          var hasJsonSales = Boolean(
            product.product_sales || product.product_sales_text,
          );
          if ((showSales || hasJsonSales) && productSales) {
            sales.textContent = productSales;
          } else {
            sales.style.display = 'none';
          }
        }

        if (button) {
          var url = product.amazon_product_url || '';
          if (url) {
            button.href = url;
            button.textContent = buttonText;
          } else {
            button.style.display = 'none';
          }
        }

        items.appendChild(node);
      });
    });
  }

  function renderBreadcrumbs(root) {
    if (!root || root.dataset.rendered) {
      return;
    }
    root.dataset.rendered = 'true';
    var nav = root.querySelector('.buyereviews-breadcrumb__nav');
    if (!nav) {
      return;
    }
    var source = root.dataset.source;
    var showHome = root.dataset.showHome !== 'false';
    var homeLabel = root.dataset.homeLabel || 'Home';
    var homeUrl = root.dataset.homeUrl || '/';
    var categoriesLabel = root.dataset.categoriesLabel || 'Categories';
    var categoriesUrl = root.dataset.categoriesUrl || '';
    var listUrl = root.dataset.listUrl || '';
    var separator = root.dataset.separator || '/';
    var categoryParam = getQueryParam('category');
    var listParam = getQueryParam('list');

    loadData(source).then(function (data) {
      var crumbs = [];
      if (showHome) {
        crumbs.push({ label: homeLabel, href: homeUrl });
      }
      crumbs.push({ label: categoriesLabel, href: categoriesUrl });

      if (categoryParam) {
        var category = findCategory(data, categoryParam);
        var categoryLabel = category ? category.category_name : categoryParam;
        var categorySlug = slugify(categoryLabel);
        var categoryLink = listParam
          ? buildUrl(listUrl, { category: categorySlug })
          : '';
        crumbs.push({
          label: categoryLabel,
          href: categoryLink,
          current: !listParam,
        });

        if (listParam) {
          var listPage = findList(category, listParam);
          var listLabel = listPage ? listPage.list_page_name : listParam;
          crumbs.push({ label: listLabel, href: '', current: true });
        }
      }

      if (categoryParam && crumbs.length > 2) {
        crumbs = crumbs.slice(2);
      }

      if (categoryParam && crumbs.length > 2) {
        crumbs = crumbs.slice(2);
      }

      nav.innerHTML = '';
      crumbs.forEach(function (item, index) {
        if (index > 0) {
          var sep = document.createElement('span');
          sep.className = 'buyereviews-breadcrumb__separator';
          sep.textContent = separator;
          nav.appendChild(sep);
        }

        if (item.href && !item.current) {
          var link = document.createElement('a');
          link.href = item.href;
          link.textContent = item.label;
          nav.appendChild(link);
        } else {
          var span = document.createElement('span');
          span.textContent = item.label;
          if (item.current) {
            span.setAttribute('aria-current', 'page');
          }
          nav.appendChild(span);
        }
      });
    });
  }

  function run() {
    document
      .querySelectorAll('[data-buyereviews-breadcrumb]')
      .forEach(renderBreadcrumbs);
    document
      .querySelectorAll("[data-buyereviews-page='categories']")
      .forEach(renderCategories);
    document
      .querySelectorAll("[data-buyereviews-page='category']")
      .forEach(renderCategoryLists);
    document
      .querySelectorAll('[data-buyereviews-summary]')
      .forEach(renderSummary);
    document
      .querySelectorAll('[data-buyereviews-products]')
      .forEach(renderProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
